import {Directive, HostListener, Input} from '@angular/core';
import {isEmpty, isString} from 'lodash';

@Directive({
    selector: '[restrictForbiddenCharInput]'
})
export class RestrictForbiddenCharacterInputDirective {

    pattern = /^[a-zA-Z0-9\s(\-)+',.\/:]*$/;

    @Input('restrictForbiddenCharInput')
    set newPattern(val) {
        if (isString(val) && !isEmpty(val)) {
            this.pattern = new RegExp(val);
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (!this.isKeyboardPasteEvent(event) && !this.pattern.test(event.key)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        if (!this.pattern.test(event.clipboardData.getData('text'))) {
            event.preventDefault();
        }
    }

    @HostListener('change', ['$event'])
    onChange(event) {
        if (!this.pattern.test(event.target.value)) {
            event.target.value = '';
        }
    }

    private isKeyboardPasteEvent(e: KeyboardEvent): boolean {
        return (e.ctrlKey || e.metaKey) && e.keyCode === 86; // key "v"
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/restrict-forbidden-character-input.directive.ts